import React, { useEffect, useState } from "react";
import "./App.css";
import { usePermissions, PermissionContext } from "./controllers/PermissionContext";
import UnderMaintenance from "./components/underMaintenance.js";
import LoginPage from "./components/LoginPage/LoginPage.js";
import ResetPassword from "./components/LoginPage/ResetPassword.js";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./components/SideBar/Sidebar.jsx";
import Dashboard from "./pages/DashBaord/Dashboard.jsx";
import SubAdminList from './pages/Accounts/SubAdmin/List.js'
import SubAdminAddEditData from './pages/Accounts/SubAdmin/AddEditData.js'
import { fetchIpAddress } from "./controllers/API"

import InvoiceList from "./pages/v1/invoice/List.js";
import InvoiceAddEditData from "./pages/v1/invoice/AddEditData.js";
import InvoicePreview from "./pages/v1/invoice/preview.js";
import BulkList from './pages/v1/invoice/bulk/List.js'
import BulkRequest from './pages/v1/invoice/bulk/CreateRequest.js'
import RetailersList from './pages/v1/invoice/bulk/RetailersList.js'
import BulkInvoicePreview from './pages/v1/invoice/bulk/BulkPreview.js'
import DownloadAllInvoice from './pages/v1/invoice/bulk/DownloadInvoice.jsx'

import CustomerDueList from './pages/v1/customer_due/List.js'
import Attendance from './pages/v1/Attendance/Callender.js'
import Transactions from "./pages/v1/transactions/List.js"
import Analyser from "./pages/v1/analyser/list.js";
import AnalyzerStatusList from "./pages/v1/analyser/AnalyzerStatusList.js";
import GeneralData from "./pages/v1/general_data/AddEditData.js";
import ActiveLog from "./pages/v1/activelogs/List.js";
import AgentList from "./pages/v1/agents/List.js";
import AgentAddEdit from "./pages/v1/agents/AddEditData.js";

import UserRequestList from  "./pages/v1/user_request/List.js";
import UserRequestView from  "./pages/v1/user_request/AddEditData.js";

import PullOutRequestList from  "./pages/v1/pull_out_request/List.js";
import PullOutRequestView from  "./pages/v1/pull_out_request/AddEditData.js";

import WinnerVoucherPreview from "./pages/v1/winning_vouchers/Preview.js";
import WinnerVoucherPreviewPDF from "./pages/v1/winning_vouchers/PreviewPDF.js";
import WinnerList from "./pages/v1/winning_vouchers/List.js";
import GenerateVoucher from "./pages/v1/winning_vouchers/AddData.js";
import AssignedWinningVoucherList from "./pages/Agents/winning_vouchers/AssignedList.js";
import WinningVoucherPreviewPDF from "./pages/Agents/winning_vouchers/PreviewPDF.js";
import AgentLogin from "./pages/Agents/Login/AgentLogin.js";

import ArchiveAddEditData from "./pages/v1/invoice/ArchiveAddEditData.js";
import InvoiceExportExcel from "./pages/v1/invoice/bulk/ExportExcel.js"

import WinningVoucher from "./pages/NonAuthPages/WinningVoucher.js";
import NotificationList from "./pages/v1/notifications/List.js";

//Hourly Analyser
import HourlyAnalyser from "./pages/v1/hourlyAnalyser/list.js";
import Settings from "./pages/v1/hourlyAnalyser/Settings.js"
import ResultAndCouponPage from "./pages/v1/hourlyAnalyser/ResultAndCouponPage.js";
import WinningCouponsCache from "./pages/v1/hourlyAnalyser/WinningCouponsCache.js";


const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const getIp = async () => {
    await fetchIpAddress();
  };
  const PERMISSION = usePermissions("FULL");
  const { refetchPermissions } = React.useContext(PermissionContext);
  const [PERMISSIONDATA, setPermissionData] = useState('');
    const getFullPermission = async () => {
      try {
        if (PERMISSION && PERMISSION?.fullAccess === 'N' && Object.keys(PERMISSION?.permissions || {}).length === 0) {
          getFullPermission();
          setPermissionData(PERMISSION?.permissions);
        } else{
          setPermissionData(PERMISSION?.permissions);
        }
      } catch (error) {
        
      }
    }
  useEffect(() => {
    const checkAuthentication = async () => {
      await getIp();
      const token = sessionStorage.getItem("TOKEN");

      const allowedRoutes = [
        "/",
        "/login",
        "/reset-password",
        "/invoice/preview",
        "/voucher-list",
        "/voucher-pdf",
        "/agent-login"
      ];
      
      // Check if route is /voucher/:order_id
      const isVoucherRoute = /^\/voucher\/[^/]+$/.test(location?.pathname);
      
      if (!allowedRoutes.includes(location?.pathname) && !isVoucherRoute) {
        if (!token) {
          navigate("/");
        } else {
          if (location?.pathname === "/dashboard") {
            refetchPermissions();
          }
        }
      }
      
    };
    checkAuthentication();
    getFullPermission();
  }, [location, navigate]);
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));

  //////////////////// notification sound //////////////////////
  useEffect(() => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener('message', event => {
            if (event.data && event.data.type === 'PLAY_NOTIFICATION_SOUND') {
              playNotificationSound();
              console.log("play sound")
            }
        });
    }
  }, []);

  const playNotificationSound = () => {
      const audio = new Audio('/notification.mp3');
      audio.play();
  };
  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/voucher/:order_id" element={ <WinningVoucher /> } />
          <Route path="/dashboard" element={ <Sidebar> <Dashboard /> </Sidebar> } />
          {(user?.admin_type === 'Super Admin') && (<>
            <Route path="/sub-admin/list" element={ <Sidebar> <SubAdminList /> </Sidebar> } />
            <Route path="/active-logs" element={ <Sidebar> <ActiveLog /> </Sidebar> } />
          </>)}

          <Route path="/sub-admin/addeditdata" element={ <Sidebar> <SubAdminAddEditData /> </Sidebar> } />
          
          {/* {(PERMISSIONDATA?.invoice?.individual === 'Y' || user?.admin_type === 'Super Admin') && (<> */}
            <Route path="/invoice/list" element={ <Sidebar> <InvoiceList /> </Sidebar> } />
            <Route path="/invoice/addeditdata" element={ <Sidebar> <InvoiceAddEditData /> </Sidebar> } />
            <Route path="/invoice/archive-addeditdata" element={ <Sidebar> <ArchiveAddEditData /> </Sidebar> } />
          {/* </>)} */}

          <Route path="/invoice/preview" element={ <InvoicePreview /> } />
          {/* {(PERMISSIONDATA?.invoice?.bulk_request === 'Y' || user?.admin_type === 'Super Admin') && (<> */}
            <Route path="/invoice/request" element={<Sidebar><BulkList/></Sidebar>} />
            <Route path="/invoice/create-request" element={<Sidebar><BulkRequest/></Sidebar>} />
            <Route path="/invoice/retailers-list/:batch_id" element={<Sidebar><RetailersList/></Sidebar>} />
            <Route path="/invoice/bulk-preview/:batch_id" element={<BulkInvoicePreview/>}/>
            <Route path="/invoice/download-all" element={<Sidebar><DownloadAllInvoice/></Sidebar>}/>
            <Route path="/invoice/export-excel" element={<Sidebar><InvoiceExportExcel/></Sidebar>}/>
          {/* </>)} */}
          
          {/* {(PERMISSIONDATA?.customer_due?.customer_list === 'Y' || user?.admin_type === 'Super Admin') && (<> */}
            <Route path="/customers-due/list" element={<Sidebar><CustomerDueList/></Sidebar>}/>
            <Route path="/customers/attendance" element={<Sidebar><Attendance/></Sidebar>}/>
            <Route path="/sales-agent/list" element={<Sidebar><AgentList/></Sidebar>}/>
            <Route path="/sales-agent/addeditdata" element={<Sidebar><AgentAddEdit/></Sidebar>}/>
            
          {/* </>)} */}

          {/* {(PERMISSIONDATA?.transaction?.list === 'Y' || user?.admin_type === 'Super Admin') && (<> */}
            <Route path="/transaction/list" element={<Sidebar><Transactions/></Sidebar>}/>
          {/* </>)} */}

          {/* {(PERMISSIONDATA?.analyser?.list === 'Y' || user?.admin_type === 'Super Admin') && (<> */}
            <Route path="/analyser" element={<Sidebar><Analyser/></Sidebar>}/>
            <Route path="/analyser/status" element={<Sidebar><AnalyzerStatusList /></Sidebar>}/>
          {/* </>)} */}

          {/* {(PERMISSIONDATA?.general_data?.update === 'Y' || user?.admin_type === 'Super Admin') && (<> */}
            <Route path="/general-data" element={<Sidebar><GeneralData /></Sidebar>}/>
          {/* </>)} */}
          {/* <Route path="/*" element={<Sidebar><UnderMaintenance /></Sidebar>}/> */}
          <Route path="/winners/voucher" element={ <Sidebar><WinnerVoucherPreview /></Sidebar> } />
          <Route path="/winners/list" element={ <Sidebar><WinnerList /></Sidebar> } />
          <Route path="/winners/generate-voucher" element={ <Sidebar><GenerateVoucher /></Sidebar> } />

          <Route path="/winners/voucher-pdf" element={ <Sidebar><WinnerVoucherPreviewPDF /></Sidebar> } />

          <Route path="/users/request-list" element={ <Sidebar><UserRequestList /></Sidebar> } />
          <Route path="/users/request-view" element={ <Sidebar><UserRequestView /></Sidebar> } />

          <Route path="/request/pull-out-list" element={ <Sidebar><PullOutRequestList /></Sidebar> } />
          <Route path="/request/pull-out-view" element={ <Sidebar><PullOutRequestView /></Sidebar> } />

          {/* Notification Routes */}
          <Route path="/notifications/list" element={ <Sidebar><NotificationList /></Sidebar> } />
          {/* End */}
          {/* //Third Party Routes */}
          <Route path="/voucher-list" element={ <AssignedWinningVoucherList /> } />
          <Route path="/agent-login" element={ <AgentLogin /> } />
          <Route path="/voucher-pdf" element={ <WinningVoucherPreviewPDF /> } />
          
          {/* Hourly Analyser */}
          <Route path="/hourly-analyser" element={ <Sidebar><HourlyAnalyser /></Sidebar> } />
          <Route path="/hourly-analyser/settings" element={ <Sidebar><Settings /></Sidebar> } />
          <Route path="/hourly-analyser/result-coupons" element={ <Sidebar><ResultAndCouponPage /></Sidebar> } />
          <Route path="/hourly-analyser/winning-coupons-cache" element={ <Sidebar><WinningCouponsCache /></Sidebar> } />
        </Routes>
      
    </div>
  );
};

export default App;
